import { TableCell, TableContainer } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled(TableCell)`
  transition: 3ms;
  /* background: #fff; */
  position: absolute;

  right: 0;

  /* margin-right: -14px; */
  /* margin-right: -28px; */

  margin-top: -10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 999;
  padding: 1.2rem 2rem !important;
  border: transparent;

  /* width: 5px; */

  button {
    margin: 0 0.5rem;
  }

  svg {
    font-size: 2rem;

    :hover {
      color: #000;
    }
  }
`;

export const WrapperContainer = styled(TableContainer)`
  height: ${({ maxHeight }) => maxHeight};
  max-height: 100%;

  position: relative;

  .MuiTableRow-root.Mui-selected,
  .MuiTableRow-root.Mui-selected:hover {
    background-color: rgba(0, 0, 0, 0.01) !important;
    box-shadow: 0px 3px 5px 0px rgb(0 0 0 / 30%);
  }

  tbody.MuiTableBody-root tr:nth-child(even) {
    background-color: rgba(0, 0, 0, 0.015);
  }
`;


